import { render, staticRenderFns } from "./adicionar.vue?vue&type=template&id=290b0450"
import script from "./adicionar.vue?vue&type=script&lang=js"
export * from "./adicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports